import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../Reveal";
import { ProductCard } from "../ProductCard";
import api from "../../lib/api";

export const Featured = ({ onQuickView }) => {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/products").then(({ data }) => setProducts(data.slice(0, 4))).catch(() => {});
  }, []);

  if (!products.length) return null;

  const spans = ["lg:col-span-7", "lg:col-span-5 lg:mt-24", "lg:col-span-5 lg:-mt-16", "lg:col-span-7 lg:mt-8"];

  return (
    <section className="relative mx-auto max-w-[1500px] px-6 py-28 md:px-10 md:py-40" data-testid="featured-section">
      <div className="mb-16 flex flex-wrap items-end justify-between gap-8 md:mb-24">
        <Reveal>
          <p className="mb-4 flex items-center gap-3 text-[0.68rem] font-bold uppercase tracking-[0.34em] text-burgundy">
            <span className="h-px w-10 bg-gold" /> The Edit
          </p>
          <h2 className="font-serif text-4xl leading-[1.05] tracking-tight text-navy sm:text-5xl lg:text-6xl">
            Worn by the bold<span className="text-gold">,</span>
            <br />
            <em className="text-navy/80">kept by the collectors</em>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <button
            onClick={() => navigate("/shop")}
            data-testid="featured-view-all"
            className="group flex items-center gap-3 border border-navy px-8 py-4 text-[0.68rem] font-bold uppercase tracking-[0.28em] text-navy transition-colors duration-400 hover:bg-navy hover:text-cream"
          >
            View the Collection
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={1.8} />
          </button>
        </Reveal>
      </div>
      <div className="grid gap-x-8 gap-y-16 sm:grid-cols-2 lg:grid-cols-12">
        {products.map((p, i) => (
          <ProductCard key={p.id} product={p} index={i} onQuickView={onQuickView} className={spans[i % 4]} />
        ))}
      </div>
    </section>
  );
};
